import React from "react";
import Search from "./Search";
import OrderBy, { OrderByInterface } from "./OrderBy";
import DateRange from "./DateRange";
import { Col, Row } from "antd";
import './style.scss';

export interface FilterInterface {
  children?: React.ReactNode;
  className?: string;
  search?: boolean;
  dateRange?: boolean;
  orderBy?: OrderByInterface;
}

const Filter = ({ children, className, search, orderBy, dateRange }: FilterInterface) => {
  let classNames = 'v-filter';
  classNames = className ? `v-filter ${className}` : classNames;

  return (
    <div className={classNames}>
      <Row>
        <Col span={16}>
          { orderBy && <OrderBy {...orderBy} /> }
        </Col>

        <Col span={8}>
          {dateRange && <DateRange />}
        </Col>
      </Row>

      {children}

      { search && <Search /> }
    </div>
  );
}

export { default as Search } from "./Search";
export { default as OrderBy } from "./OrderBy";
export default Filter;
